export class PRODSTATUS {
    Type: string = "PRODSTATUS";
    MachineId: string;
    DeviceId: string;
    SerialNumber: string;
    ReferenceId: string;
    ReferenceCode: string;
    ReferenceDescription: string;
    StartDate: Date;
    EndDate: Date;
    Info: string;
    Of: string;
    PhaseId: string;
    PhaseCode: string;
    PhaseDescription: string;
    IsProduction: boolean;
    IsStart: boolean;
}